export default __webpack_public_path__ + "media/src/assets/images/StatusChip-5ba909a15b19f5572e2ff3750ce43d6f.svg";